'use client';

import { Separator, Text } from '@/shared/ui/core';
import { HaveAnAccount } from '@/shared/ui/kit/have-an-account';
import { RegistrationCardFooter } from '@/shared/ui/layout/registration-card';
import { getStepNumber, WizardState } from '@/widgets/registration-wizard/model/wizard-state';
import type { ReactNode } from 'react';
import styles from './wizard-footer.module.scss';


type Props = {
    left?: ReactNode;
    right?: ReactNode;
    state: WizardState;
};


export const WizardFooter = ({ left, right, state }: Props) => {
    return (
        <RegistrationCardFooter
            data-template="wizard-footer"
            className={ styles.root }
        >
            <div className={ styles.bottom }>
                <div className={ styles.left }>
                    { left }
                </div>

                <Text
                    as="div"
                    className={ styles.center_content_text }
                >
                    Step { getStepNumber(state.step) }
                </Text>

                <div className={ styles.bottom_inner }>
                    <HaveAnAccount/>

                    <Separator
                        orientation="vertical"
                        className={ styles.footer_separator }
                    />
                </div>
            </div>

            <div className={ styles.right }>
                { right }
            </div>
        </RegistrationCardFooter>
    );
};
